<template>
  <div>
    <v-dialog
      :value="privacyDialogOpen"
      @input="$emit('onClose')"
      persistent
      scollable
      :fullscreen="fullscreen"
      max-width="65vw"
      max-height="65vh"
      scrollable
      content-class="rounded-dialog"
    >
      <v-card
        :class="classes"
        :style="styles + ';' + gradient"
        :elevation="component.card.elevation"
      >
        <view-text
          :settings="component.title"
          value="Privacy Policy"
        ></view-text>
        <div class="content-container" :style="scrollbarStyle">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            centered
            :color="component.title.color"
          >
            <v-tab v-if="promoterTitle">
              <span :style="'color: ' + component.title.color">{{
                promoterTitle
              }}</span>
            </v-tab>
            <v-tab v-if="operatorTitle">
              <span :style="'color: ' + component.title.color">{{
                operatorTitle
              }}</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="transparent-bg full-width mt-6">
            <v-tab-item v-if="promoterTitle" class="px-12">
              <div v-html="promoterPrivacy" :style="textFormat"></div>
            </v-tab-item>
            <v-tab-item v-if="operatorTitle" class="px-12">
              <div v-html="operatorPrivacy" :style="textFormat"></div>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="onClosePrivacyDialog"
            :color="component.title.color"
            :dark="!component.button.dark"
            class="mt-3"
            elevation="0"
            text
          >
            {{ $t("CLOSE") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ViewText from "../Text.vue";
export default {
  props: [
    "privacyDialogOpen",
    "onClose",
    "component",
    "promoterPrivacy",
    "operatorPrivacy",
    "promoterTitle",
    "operatorTitle"
  ],
  components: {
    ViewText
  },
  data() {
    return { tab: 0 };
  },
  computed: {
    currentProgram() {
      return this.$store.getters.currentProgram;
    },
    webTheme() {
      if (this.currentProgram) {
        return this.$store.getters.currentProgram.webTheme;
      }
      return {};
    },
    gradient() {
      if (this.component.card.color.type === "gradient") {
        var color = this.component.card.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return "background: " + this.component.card.color.solidColor.hexa + ";";
      }
    },
    styles() {
      var styles =
        "margin-bottom: 0px ;" +
        "margin-top: " +
        this.component.card.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.card.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.card.margin.right +
        "px ;" +
        "padding-bottom: 0px ;" +
        "padding-top: " +
        this.component.card.padding.top +
        "px ;" +
        "padding-left: " +
        this.component.card.padding.left +
        "px ;" +
        "padding-right: " +
        this.component.card.padding.right +
        "px ;" +
        "border: " +
        this.component.card.borderSize +
        "px solid " +
        this.component.card.borderColor.hexa +
        "; ";
      return styles;
    },
    classes() {
      var classes = this.component.card.rounded + " mt-n3 pb-3";
      return classes;
    },
    textFormat() {
      var styles = "color: " + this.component.signing.color + "!important;";
      return styles;
    },
    fullscreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
      }
    },
    scrollbarStyle() {
      let baseColor = "128, 128, 128"; // Default gray

      if (
        this.component &&
        this.component.title &&
        this.component.title.color &&
        this.component.title.color.rgba
      ) {
        baseColor = `${this.component.title.color.rgba.r}, ${this.component.title.color.rgba.g}, ${this.component.title.color.rgba.b}`;
      }

      return {
        "--scrollbar-color": `rgba(${baseColor}, 0.5)`,
        "--scrollbar-hover-color": `rgba(${baseColor}, 0.7)`
      };
    }
  },
  methods: {
    onClosePrivacyDialog() {
      this.$emit("onClose");
    }
  }
};
</script>

<style>
.rounded-dialog {
  border-radius: 24px !important;
  overflow: hidden;
}
.scroll {
  position: relative;
  margin: auto;
  height: auto;
}
.privacy-text {
  font-size: 13px !important;
  font-family: "Roboto", sans-serif !important;
}
.ql-indent-1 {
  padding-left: 1.5em;
}
.ql-indent-2 {
  padding-left: 3em;
}
.ql-indent-3 {
  padding-left: 4.5em;
}
.ql-indent-4 {
  padding-left: 6em;
}
.ql-indent-5 {
  padding-left: 7.5em;
}
.ql-indent-6 {
  padding-left: 9em;
}
.ql-indent-7 {
  padding-left: 10.5em;
}
.ql-indent-8 {
  padding-left: 12em;
}
.ql-indent-9 {
  padding-left: 13.5em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-4;
}
.transparent-bg >>> .v-window__container,
.transparent-bg >>> .v-window-item,
.transparent-bg >>> .v-tabs-items,
.transparent-bg >>> .v-tabs__container,
.transparent-bg >>> .v-tabs-bar {
  background-color: transparent !important;
}

.transparent-bg >>> .v-window-item:before,
.transparent-bg >>> .v-tabs-items:before {
  background-color: transparent !important;
}

.v-tabs-items {
  background-color: transparent !important;
}

.v-tab-item {
  background-color: transparent !important;
}

.v-tabs-items > .v-window__container {
  background-color: transparent !important;
}
.full-width {
  width: 100%;
}
.tab-content-fullwidth {
  width: 100%;
  display: flex;
}

.tab-content-fullwidth > div {
  flex: 1;
  width: 100%;
}

.content-container {
  position: relative;
  margin: auto;
  height: auto;
  max-height: 60vh;
  overflow-y: auto;
  width: 100%;
  padding: 0 16px;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-color) transparent;
}

/* Custom scrollbar for Webkit browsers (Chrome, Safari, newer Edge) */
.content-container::-webkit-scrollbar {
  width: 10px;
}

.content-container::-webkit-scrollbar-track {
  background: transparent;
}

.content-container::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  border-radius: 10px;
  border: 2px solid transparent;
}

.content-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-hover-color);
}
</style>
